<template>
  <table-agency-contract
    v-bind="$attrs"
    :type="$options.TYPE"
    :edit-data="vEditData"
    :fetch-fn="_fetchData"
    :fetch-filters="fetchFilters"
    :right-edit="$options.RIGHT_EDIT"
    :right-delete="$options.RIGHT_DELETE"
    :right-sign="$options.RIGHT_SIGN"
  >
    <template
      v-for="(slot, k) in $slots"
      #[k]
    >
      <slot :name="k" />
    </template>
    <template
      v-for="(slot, k) in $scopedSlots"
      #[k]="props"
    >
      <slot
        v-bind="props"
        :name="k"
      />
    </template>
  </table-agency-contract>
</template>

<script>
import TableAgencyContract from 'components/Table/TableAgencyContract'
import { CONTRACT_TYPES_AGENT } from '@/consts/data/contract'
import { fetchAgencyAgentContracts } from '@/utils/api/agency/agencyContractsAgent'
import {
  ACCOUNT_RIGHT_DELETE_AGENCY_CONTRACT_AGENT,
  ACCOUNT_RIGHT_EDIT_AGENCY_CONTRACT_AGENT,
  ACCOUNT_RIGHT_SIGN_CREATE_AGENCY_CONTRACT_AGENT
} from '@/consts/rights'

export default {
  name: 'TableAgencyContractAgent',
  components: { TableAgencyContract },
  TYPE: CONTRACT_TYPES_AGENT,
  RIGHT_EDIT: ACCOUNT_RIGHT_EDIT_AGENCY_CONTRACT_AGENT,
  RIGHT_DELETE: ACCOUNT_RIGHT_DELETE_AGENCY_CONTRACT_AGENT,
  RIGHT_SIGN: ACCOUNT_RIGHT_SIGN_CREATE_AGENCY_CONTRACT_AGENT,
  props: {
    agent: {
      type: Object,
      default: undefined
    }
  },
  computed: {
    fetchFilters () {
      if (this.agent) {
        return {
          agent: [this.agent.slug]
        }
      }
      return {}
    },
    vEditData () {
      if (this.agent) {
        return {
          agent: this.agent
        }
      }
      return {}
    }
  },
  methods: {
    _fetchData: fetchAgencyAgentContracts
  }
}
</script>

<style scoped>

</style>
